import Index from "../../pages/snail/doubleDan/index";
// import Query from "../../pages/snail/doubleDan/query"
// import Pc from "../../pages/snail/doubleDan/pc";

const base = "doubleDan";

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  // {
  //   path: `/${base}/query*`,
  //   name: `${base}-query`,
  //   component: Query
  // },
  // {
  //   path: `/${base}/pc`,
  //   name: `${base}-pc`,
  //   component: Pc
  // }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/snail/doubleDan.js